import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function SnackWarningSection() {
  return <section className="bg-[#1f2e10] text-white py-16 px-4 border-y border-[#c4f000]/20" data-id="element-156">
      <div className="max-w-4xl mx-auto text-center" data-id="element-157">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-[#c4f000] mb-6 leading-tight uppercase" data-id="element-158">
          The Truth About School Lunches
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl font-bold text-white mb-6" data-id="element-159">
          Did you know your child eats between 700 and 900 snacks and meals a
          year?
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-300 mb-6" data-id="element-160">
          If those meals consist only of store-bought cookies, chips, and sugary
          juice boxes, their development is at risk. Excess sugar, trans fats,
          and preservatives aren't just affecting their weight—they are draining
          their energy, focus, and immune system.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl font-semibold text-white mb-10" data-id="element-161">
          We know you want the best for them. But we also know you're exhausted.
          That’s why Happy Lunchbox is for you.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} data-id="element-162">
          <CTAButton href="#offer" data-id="element-163">
            YES! I WANT THE HAPPY LUNCHBOX SYSTEM NOW!
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}